<script lang="ts">
  import { community } from "$lib/client/stores/nucamp-community";

  function toggleMenuOpen(event: MouseEvent) {
    const element = event.target as HTMLElement;
    const eventTarget = event.currentTarget as HTMLElement;

    // Find the first parent "details" element
    let detailsElement = element.closest('details');

    if (element.tagName === "SUMMARY" || element.tagName === "A") {
      // Get all sibling "details" elements within the same menu
      let allDetails = eventTarget.closest("ul")?.querySelectorAll('li > details') || [];

      if (detailsElement && !detailsElement.hasAttribute('open')) {
        // Toggle the "open" attribute on the "details" element
        detailsElement.toggleAttribute('open');
      }
      // Close all other "details" elements
      allDetails.forEach((detail) => {
        if (detail !== detailsElement || (event.type === "click" && element.tagName === "A")) {
          detail.removeAttribute('open');
        }
      });
    }
  }

</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
<ul id="nucampmenu" class="{$$props.class || ''} nucampnavmenu">
  <li>
    {#if $community}
      <a href="/community/{$community.urlId}" class="lg:pl-0 xl:pl-4">{$community.name}</a>
    {:else}
      <a href="/community/near/you" class="lg:pl-0 xl:pl-4">Community</a>
    {/if}
  </li>
  <!-- svelte-ignore a11y-mouse-events-have-key-events -->
  <li on:mouseover={(event) => toggleMenuOpen(event)}>
    <details>
      <summary>Bootcamps</summary>
      <ul class="rounded-none p-2 !mt-0 bg-base-100">
        <li>
          <a href="/bootcamp-overview/cybersecurity-ethicalhacking-network-defense" class="whitespace-nowrap">
            <div class="max-md:hidden w-12">
              <img class="h-6" loading="lazy" src="/assets/imgs/bootcamps/cyberfundamentals.svg" alt="Cybersecurity Fundamentals">
            </div>
            <div>
              Cybersecurity Fundamentals
            </div>
          </a>
        </li>
        <li>
          <a href="/bootcamp-overview/web-development-fundamentals" class="whitespace-nowrap">
            <div class="max-md:hidden w-12">
              <img class="h-6" loading="lazy" src="/assets/imgs/bootcamps/beginner.svg" alt="Web Development Fundamentals">
            </div> 
            <div>
              Web Development Fundamentals
            </div>
          </a>
        </li>
        <li>
          <a href="/bootcamp-overview/back-end-sql-devops-python" class="whitespace-nowrap">
            <div class="max-md:hidden w-12">
              <img class="h-6" loading="lazy" src="/assets/imgs/bootcamps/backend.svg" alt="Backend, SQL, and DevOps with Python">
            </div>
            <div>
              Backend, SQL, and DevOps with Python
            </div>
          </a>
        </li>
        <li>
          <a href="/bootcamp-overview/front-end-web-development" class="whitespace-nowrap">
            <div class="max-md:hidden w-12">
              <img class="h-6" loading="lazy" src="/assets/imgs/bootcamps/intermediate.svg" alt="Front End Web + Mobile Development">
            </div>
            <div>
              Front End Web + Mobile Development
            </div>
          </a>
        </li>
        <li>
          <a href="/bootcamp-overview/full-stack-web-mobile-development" class="whitespace-nowrap">
            <div class="max-md:hidden w-12">
              <img class="h-6" loading="lazy" src="/assets/imgs/bootcamps/advanced.svg" alt="Full Stack Web + Mobile Development">
            </div>
            <div>
              Full Stack Web + Mobile Development
            </div>
          </a>
        </li>
        <li>
          <a href="/bootcamp-overview/job-hunting" class="whitespace-nowrap">
            <div class="max-md:hidden w-12">
              <img class="h-6" loading="lazy" src="/assets/imgs/bootcamps/careerservices.svg" alt="Job Hunting">
            </div>
            <div>
              Job Hunting
            </div>
          </a>
        </li>
        <hr class="h-[2px] bg-gray-200 border-0 dark:bg-gray-700 my-2">
        <li>
          <a href="/complete-bootcamp/software-engineering" class="whitespace-nowrap">
            <div class="max-md:hidden w-12">
              <img class="h-6" loading="lazy" src="/assets/imgs/bootcamps/illustration-complete-computer2.svg" alt="Complete Software Engineering Bootcamp Path">
            </div>
            <div>
              Complete Software Engineering Bootcamp Path
            </div>
          </a>
        </li>
      </ul>
    </details>
  </li>
  <!-- svelte-ignore a11y-mouse-events-have-key-events -->
  <li on:mouseover={(event) => toggleMenuOpen(event)}>
    <details>
      <summary>Financing</summary>
      <ul class="rounded-none p-2 !mt-0">
        <li><a href="/financing" class="whitespace-nowrap">Fair Student Agreement</a></li>
        <li><a href="/scholarships" class="whitespace-nowrap">Scholarships</a></li>
      </ul>
    </details>
  </li>
  <!-- svelte-ignore a11y-mouse-events-have-key-events -->
  <li on:mouseover={(event) => toggleMenuOpen(event)}>
    <details>
      <summary>Job Outcomes</summary>
      <ul class="rounded-none p-2 !mt-0">
        <li><a href="/careerservices" class="whitespace-nowrap">Career Services</a></li>
        <li><a href="/newcareers" class="whitespace-nowrap">Graduate Stories</a></li>
        <li><a href="/graduates/projects" class="whitespace-nowrap">Graduate Projects</a></li>
      </ul>
    </details>
  </li>
  <!-- svelte-ignore a11y-mouse-events-have-key-events -->
  <li on:mouseover={(event) => toggleMenuOpen(event)}>
    <details>
      <summary>Business</summary>
      <ul class="rounded-none p-2 !mt-0">
        <li><a href="/business" class="whitespace-nowrap">Nucamp for Business</a></li>
        <li><a href="/business/jobboard" class="whitespace-nowrap">Hire a Grad!</a></li>
        <li><a href="/affiliate" class="whitespace-nowrap">Affiliate Program</a></li>
      </ul>
    </details>
  </li>
  <!-- svelte-ignore a11y-mouse-events-have-key-events -->
  <li>
    <a href="/blogs?page=1">Blogs</a>
  </li>
  <!-- svelte-ignore a11y-mouse-events-have-key-events -->
  <li on:mouseover={(event) => toggleMenuOpen(event)}>
    <details>
      <summary>More</summary>
      <ul class="rounded-none p-2 !mt-0">
        <li><a href="/technews" class="whitespace-nowrap">Latest US Tech News</a></li>
        <!-- <li><a href="/free-workshops" class="whitespace-nowrap">Free Workshops</a></li> -->
        <li><a href="/number1" class="whitespace-nowrap">Number 1</a></li>
        <li><a href="/frequentlyaskedquestions" class="whitespace-nowrap">FAQ</a></li>
        <li><a href="/aboutus" class="whitespace-nowrap">About</a></li>
        <li><a href="https://mautic.nucamp.co/job-application" target="_blank" class="whitespace-nowrap">Jobs</a></li>
      </ul>
    </details>
  </li>
</ul>

<style lang="postcss">
  summary, li {
    @apply font-semibold;
  }
</style>